import {
   rand,
   randNumber,
   randBoolean,
   randCompanyName,
   randEmail,
   randFirstName,
   randLastName,
   randRecentDate,
   randPersonTitle,
   randPhoneNumber,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';

import {
   AdminUserListItem,
   AdminUser,
} from './admin-user';

import { SourceSystems } from '../admin-enum.mock';

import { Routes } from '../admin-portal-routes';

export class MockAdminUserListItem extends AdminUserListItem {
   constructor() {
      super({
         email: randEmail(),
         active: randBoolean(),
         firstName: randFirstName(),
         lastName: randLastName(),

         status: rand([ 'UNCONFIRMED', 'CONFIRMED', 'ARCHIVED', 'COMPROMISED', 'UNKNOWN', 'RESET_REQUIRED', 'FORCE_CHANGE_PASSWORD' ]),
         last_session: randRecentDate(),

         portals: Array.from({ length: randNumber({ min: 1, max: 3 }) }, _ =>
            ({
               name: rand( Routes ).id,
               accounts: randNumber(),
            })
         ).filter(( account, index, array ) => array.map( a => a.name ).indexOf( account.name ) === index )
      });
   }
}

export class MockAdminUser extends AdminUser {
   constructor() {
      super({
         firstName: randFirstName(),
         lastName: randLastName(),
         active: randBoolean(),
         emailVerified: randBoolean(),
         lastAuthentication: optional(80) ? randRecentDate() : null,
         preferredBrand: rand([ 'radiant', 'adcomworldwide', 'airgroup' ])
      });

      const portals = [ 'customer', 'vendor', '4pl', 'agent' ];
      const portalsLength = randNumber({ min: 1, max: portals.length });

      for ( let z = 0; z <= portalsLength; z++ ) {
         const currentPortal = rand(
            portals.filter( portal => !this.portals.map( p => p.portalName ).includes( portal ))
         );

         const sourceSystem = SourceSystems[currentPortal];
         const services = [ ...new Set( sourceSystem?.map( ss => ss.services )
            .reduce(( a, c ) => [ ...a, ...c ], [] ) )];

         this.portals.push({
            portalName: currentPortal,
            firstName: randFirstName(),
            lastName: randLastName(),
            title: optional() ? randPersonTitle() : null,
            phone: optional() ? randPhoneNumber() : null,
            lastSessionCreation: optional(70) ? randRecentDate() : null,
            lastTermsUse: optional() ? randRecentDate() : null,
            lastTermsConditions: optional() ? randRecentDate() : null,
            accounts: Array.from({ length: randNumber({ min: 1, max: 40 })},
               () => ({
                  id: randNumber(),
                  name: randCompanyName(),
                  primary: randBoolean(),
                  services: services?.length ? [ ...new Set( Array.from({
                     length: randNumber({ min: 1, max: 5 })
                  }, () => rand( services )?.id ) )] : [],
               })).map(( a, i, arr ) => arr.map( j => // single primary account
                  j.primary ).indexOf( true ) === i ? a : ({ ...a, primary: false })),
         });
      }
   }
}
